module.exports = __webpack_public_path__ + "img/product_127.a8a367f.webp";